import { decodeDelimitedArray, encodeDelimitedArray, QueryParamConfig } from 'use-query-params'

export const CommaArrayParam: QueryParamConfig<string[] | null> = {
  encode: (array: string[] | null | undefined) => encodeDelimitedArray(array, ','),

  decode: (arrayStr: string | string[] | null | undefined) => decodeDelimitedArray(arrayStr, ','),
}

export type ParsedQueryCategory = { id: string; slug: string }

export const parseQueryCategories = (queryCategories: string[] | null): ParsedQueryCategory[] => {
  if (!queryCategories) return []
  return queryCategories.map(cat => {
    const catArr = cat.split('_')
    const id = catArr.pop()
    const slug = catArr.join('_')
    return { id, slug }
  })
}
export const stringifyQueryCategories = (categories: { id: string | number; slug: string }[] | null): string => {
  if (categories) {
    return `?categories=${categories.map(cat => `${cat.slug}_${cat.id}`).join(',')}`
  }
  return ''
}
